/**
 * Roles soportados por Pulso17.
 * Cada usuario tiene exactamente un rol, y cada rol tiene su propio
 * dashboard y su propia sección de la navegación inferior.
 */
export const ROLES = {
  DATA_ENTRY: 'data_entry',
  ANALYST: 'analyst',
  ADMIN: 'admin',
};

/** Etiquetas legibles para mostrar en la interfaz. */
export const ROLE_LABELS = {
  [ROLES.DATA_ENTRY]: 'operador',
  [ROLES.ANALYST]: 'analista',
  [ROLES.ADMIN]: 'administrador',
};

/** Ruta "home" a la que se redirige cada rol tras iniciar sesión. */
export const ROLE_HOME_ROUTE = {
  [ROLES.DATA_ENTRY]: '/data-entry',
  [ROLES.ANALYST]: '/analyst',
  [ROLES.ADMIN]: '/admin',
};

/**
 * La API real entrega los roles del usuario como un arreglo en
 * español (ej. `roles: ["administrador"]`). Este mapa traduce esos
 * valores al enum interno `ROLES`.
 *
 * ⚠️ `"administrador"` y `"operativo"` ya están confirmados contra la
 * API real; el valor de analista sigue siendo una suposición a partir
 * de `ROLE_LABELS`. Ajusta esto apenas confirmes el string exacto que
 * devuelve el backend para ese rol.
 */
export const API_ROLE_TO_ROLE = {
  administrador: ROLES.ADMIN,
  analista: ROLES.ANALYST,
  operador: ROLES.DATA_ENTRY,
};

/**
 * Devuelve el primer rol interno reconocido dentro del arreglo `roles`
 * que entrega la API (comparación insensible a mayúsculas). Si ninguno
 * coincide, retorna `null` para que `RoleRoute` mande a `/unauthorized`
 * en vez de romper la app.
 *
 * @param {string[]} apiRoles
 * @returns {string|null}
 */
export function mapApiRoleToRole(apiRoles = []) {
  const normalized = apiRoles.map((r) => String(r).toLowerCase());
  return normalized.map((r) => API_ROLE_TO_ROLE[r]).find(Boolean) ?? null;
}
